import { ExperimentType } from 'modules/graphql';
import {
  ExperimentCampaignType,
  ExperimentFilterInfoInput,
  ExperimentsTableMenuItemOption,
  SystemConversionEventDefinition,
  TableFilter,
} from '../types';
import { ALL_EXPERIMENT_STATUSES } from './experimentTabs';

const baseMenuOption = {
  options: [],
  isVisible: true,
  label: '',
};

const baseMenuOptionWithSubMenu = {
  ...baseMenuOption,
  hasFilter: true,
  hasCountBadge: false,
};

const baseMenuTitle = {
  ...baseMenuOption,
  isTitle: true,
};

const experimentFilterMenu: ExperimentsTableMenuItemOption[] = [
  {
    ...baseMenuTitle,
    id: 'experimentFilterHeading',
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.EXPERIMENT_MODIFIED_BY,
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.EXPERIMENT_TEST_SUBJECTS,
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.EXPERIMENT_WINNING_CRITERIA,
  },
  {
    ...baseMenuOptionWithSubMenu,
    hasFilter: false,
    id: TableFilter.EXPERIMENT_WINNER_SELECTED,
  },
  {
    ...baseMenuOptionWithSubMenu,
    hasFilter: false,
    id: TableFilter.EXPERIMENT_SPLIT_VARIATIONS_RANDOMLY,
  },
];

const campaignFilterMenu: ExperimentsTableMenuItemOption[] = [
  {
    ...baseMenuTitle,
    id: 'campaignFilterHeading',
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.CAMPAIGN_TYPE,
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.CAMPAIGN_MEDIUM,
  },
  {
    ...baseMenuOptionWithSubMenu,
    id: TableFilter.CAMPAIGN_LABELS,
  },
];

export const initialExperimentsTableFilterMenu = [...experimentFilterMenu, ...campaignFilterMenu];

export const initialTableFilterInfoInput: ExperimentFilterInfoInput = {
  modifiedBy: null,
  experimentTypes: null,
  winningCriteria: {
    systemConversionEvents: null,
    conversionEventIds: null,
  },
  winnerSelected: null,
  splitVariationsEvenly: null,
  statuses: ALL_EXPERIMENT_STATUSES,

  campaignTypes: null,
  messageMediums: null,
  labelIds: null,
};

export enum Bool {
  TRUE = 'yes',
  FALSE = 'no',
}

export const booleanResponse = [Bool.TRUE, Bool.FALSE];

export const booleanResponseMap = {
  [Bool.TRUE]: true,
  [Bool.FALSE]: false,
};

export const CONVERSION_EVENT_ID_DELIMITER = '*';

export const experimentCampaignTypeDefinition = Object.values(ExperimentCampaignType);

export const experimentTestSubjects = Object.values(ExperimentType);

export const systemConversionEvents = Object.values(SystemConversionEventDefinition);
